export function trackEvent(category, action, label = '') {
  if (typeof window !== 'undefined' && window.gtag !== undefined) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
    })
  }
}
